<p *ngIf="!selectedOrder && !selectedOrderDetails" class="instruction" [@fade]>
  (Select an Order to view/manage its details)
</p>

<div *ngIf="selectedOrder && selectedOrderDetails" [@fade]>
  <ul ngbNav #nav="ngbNav" class="nav-tabs">
    <li [ngbNavItem]="1" *ngIf="details">
      <a class="ngbNavLink" ngbNavLink>Details</a>
      <ng-template ngbNavContent>
        <!-- Patient Information -->
        <div *ngIf="selectedOrder && selectedOrderDetails" class="d-flex flex-wrap gap-3 mt-3">
          <h6>
            Patient Name:
            <strong
              >{{ selectedOrder.patient.last_name }},
              {{ selectedOrder.patient.first_name }}</strong
            >
          </h6>
          <div
            *ngIf="this.userRole !== 'location_admin' && this.userRole !== 'location_user'"
            class="rename-btn"
          >
            <i
              class="fa fa-pencil-square fa-lg pointer"
              (click)="updatePatient()"
              aria-hidden="true"
            ></i>
          </div>
          <h6 class="ml-5">
            DOB:
            <strong>{{ selectedOrder.patient.date_of_birth }}</strong>
          </h6>
          <h6 class="ml-5">
            MRN: <strong>{{ selectedOrder.patient.med_rec_nbr }}</strong>
          </h6>
          <h6 class="ml-5">
            <label>
              Enrolled:
              <input
                onclick="this.checked=!this.checked;"
                type="checkbox"
                [checked]="patient_enrolled"
            /></label>
          </h6>
            <h6 class="ml-3">Primary Payer ID: <strong>{{ selectedOrderDetails?.primary_payer_id || 'N/A' }}</strong></h6>
            <h6 class="ml-3">Primary Payer Name: <strong>{{ selectedOrderDetails?.primary_payer_name || 'N/A' }}</strong></h6>
            <h6 class="ml-3">Primary Payer Group: <strong>{{ selectedOrderDetails?.primary_payer_group || 'N/A' }}</strong></h6>
        </div>

        <!-- Section 2: Forms (TOP) -->
        <div class="forms-section">
        <div class="forms-row">
        <div class="form-col">
        <!-- Order Details -->
        <div
          *ngIf="selectedOrder && selectedOrderDetails"
          class="detail-form"
        >
          <div class="detail-form__grid">
            <div class="detail-form__group">
              <label class="detail-form__label">Provider</label>
              <select
                class="detail-form__input"
                (change)="changeOrderProvider($event)"
                *ngIf="userRole === 'practice_admin'"
              >
                <option
                  *ngFor="let provider of practiceProviders"
                  [value]="provider | json"
                  [selected]="selectedOrderProvider.id === provider.provider_id"
                >
                  {{ provider.description }}
                </option>
              </select>
              <input
                class="detail-form__input"
                [value]="selectedOrder.provider.name"
                disabled
                readonly
                type="text"
                *ngIf="userRole != 'practice_admin'"
              />
            </div>
            <div class="detail-form__group">
              <label class="detail-form__label">Order Summary</label>
              <input
                class="detail-form__input"
                #order_summary
                type="text"
                [(ngModel)]="selectedOrder.order_summary"
                disabled
                readonly
              />
            </div>
            <div class="detail-form__group">
              <label class="detail-form__label">Facility</label>
              <select
                class="detail-form__input"
                (change)="changeLocation($event)"
                *ngIf="userRole === 'practice_admin'"
              >
                <option
                  *ngFor="let loction of clientLocations"
                  [value]="loction.description"
                  [selected]="
                    selectedLocation?.description === loction.description
                  "
                >
                  {{ loction.description }}
                </option>
              </select>
              <input
                class="detail-form__input"
                [value]="selectedOrder.order_facility"
                disabled
                readonly
                type="text"
                *ngIf="userRole != 'practice_admin'"
              />
              <ng-container *ngIf="showFacility">
                <input
                  class="detail-form__input mt-1"
                  type="text"
                  (change)="facilityItem($event)"
                  placeholder="Add new location here..."
                />
              </ng-container>
            </div>
            <div class="detail-form__group">
              <label class="detail-form__label">Cell Phone</label>
              <input
                class="detail-form__input"
                #patient_phone
                type="text"
                [(ngModel)]="selectedOrder.patient_phone"
                mask="(000) 000-0000"
                disabled
                readonly
              />
            </div>
          </div>

          <div class="detail-form__group detail-form__full-width">
            <label class="detail-form__label">Notes</label>
            <textarea
              class="detail-form__input detail-form__textarea"
              #physician_notes
              [(ngModel)]="selectedOrder.physician_notes"
              name="physician_notes"
              id="physician_notes"
              rows="2"
              placeholder="Enter notes here..."
              disabled
              readonly
            ></textarea>
          </div>

          <div class="detail-form__grid">
            <div class="detail-form__group">
              <label class="detail-form__label">Date</label>
              <div class="input-group detail-form__date-input">
                <input
                  class="form-control"
                  placeholder="yyyy-mm-dd"
                  name="dp"
                  [(ngModel)]="orderDatePickerModel"
                  ngbDatepicker
                  #d="ngbDatepicker"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-outline-secondary"
                    (click)="d.toggle()"
                    type="button"
                  >
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="detail-form__group tp-wrapper">
              <label class="detail-form__label">Time</label>
              <div class="detail-form__time-row">
                <div class="tp-display" (click)="timeToggle = !timeToggle">
                  <i class="fa fa-clock-o tp-display__icon" aria-hidden="true"></i>
                  <span class="tp-display__value">
                    {{ time.hour | number:'2.0-0' }}:{{ time.minute | number:'2.0-0' }} {{ ampm }}
                  </span>
                  <i class="fa fa-chevron-down tp-display__chevron" [class.tp-display__chevron--open]="timeToggle" aria-hidden="true"></i>
                </div>
              </div>

              <div *ngIf="timeToggle" class="tp-popup">
                <div class="tp-popup__header">
                  <span class="tp-popup__title">Select Time</span>
                  <button class="tp-popup__close" (click)="timeToggle = false" type="button">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>

                <div class="tp-popup__ampm">
                  <button class="tp-ampm-btn" [class.tp-ampm-btn--active]="ampm === 'AM'" (click)="ampm = 'AM'">AM</button>
                  <button class="tp-ampm-btn" [class.tp-ampm-btn--active]="ampm === 'PM'" (click)="ampm = 'PM'">PM</button>
                </div>

                <div class="tp-popup__body">
                  <div class="tp-section">
                    <div class="tp-section__title">Hours</div>
                    <div class="tp-grid">
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 1"  (click)="time.hour = 01">01</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 2"  (click)="time.hour = 02">02</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 3"  (click)="time.hour = 03">03</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 4"  (click)="time.hour = 04">04</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 5"  (click)="time.hour = 05">05</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 6"  (click)="time.hour = 06">06</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 7"  (click)="time.hour = 07">07</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 8"  (click)="time.hour = 08">08</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 9"  (click)="time.hour = 09">09</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 10" (click)="time.hour = 10">10</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 11" (click)="time.hour = 11">11</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.hour == 12" (click)="time.hour = 12">12</button>
                    </div>
                  </div>

                  <div class="tp-section">
                    <div class="tp-section__title">Minutes</div>
                    <div class="tp-grid">
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 5"  (click)="time.minute = 05">05</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 10" (click)="time.minute = 10">10</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 15" (click)="time.minute = 15">15</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 20" (click)="time.minute = 20">20</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 25" (click)="time.minute = 25">25</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 30" (click)="time.minute = 30">30</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 35" (click)="time.minute = 35">35</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 40" (click)="time.minute = 40">40</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 45" (click)="time.minute = 45">45</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 50" (click)="time.minute = 50">50</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 55" (click)="time.minute = 55">55</button>
                      <button class="tp-cell" [class.tp-cell--active]="time.minute == 60" (click)="time.minute = 60">60</button>
                    </div>
                  </div>
                </div>

                <div class="tp-popup__footer">
                  <button class="tp-done-btn" (click)="timeToggle = false" type="button">
                    <i class="fa fa-check mr-1" aria-hidden="true"></i> Done
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-form__actions">
            <button class="btn btn-danger btn-sm" (click)="resetScheduledDate()">
              Reset Date
              <i class="fa fa-repeat ml-1" aria-hidden="true"></i>
            </button>
            <button
              class="btn btn-primary style-btn btn-sm"
              (click)="
                updateOrderDetails(
                  order_summary.value,
                  patient_phone.value,
                  physician_notes.value
                )
              "
            >
              Update <i class="fa fa-floppy-o ml-1" aria-hidden="true"></i>
            </button>
            <button
              *ngIf="userRole === 'practice_admin'"
              class="btn btn-danger btn-sm"
              (click)="deleteOrder()"
            >
              Delete Order <i class="fa fa-times ml-1" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        </div>
        <!-- Form 2: Steps + Notes Editor -->
        <div class="form-col">
        <div *ngIf="selectedOrderDetails" class="steps-form">
          <!-- Notes Editor -->
          <div class="steps-form__section">
            <h6 class="steps-form__heading">Notes</h6>
            <div class="steps-form__editor-wrap">
              <ckeditor [editor]="editor" [(ngModel)]="notes"></ckeditor>
            </div>
            <div class="steps-form__note-actions">
              <button
                *ngIf="!isEditing; else updateButton"
                class="btn btn-primary style-btn btn-sm"
                (click)="createOrderNote()"
              >
                Create
                <i class="fa fa-floppy-o ml-1" aria-hidden="true"></i>
              </button>
              <ng-template #updateButton>
                <button
                  class="btn btn-primary style-btn btn-sm"
                  (click)="saveUpdatedNote()"
                >
                  Update
                  <i class="fa fa-check ml-1" aria-hidden="true"></i>
                </button>
              </ng-template>
            </div>
          </div>

          <!-- Steps Table -->
          <div class="steps-form__section">
            <h6 class="steps-form__heading">Order Steps</h6>
            <div class="steps-form__table-wrap">
              <app-table-pagination-client
                #steps_table
                [headers]="orderStepsTableHeaders"
                [data]="selectedOrderStepsTableData"
                [selectContent]="selectStep"
                [selectedContent]="selectedStep"
                [paginateId]="3"
                [pageSize]="6"
                [currentPage]="1"
                [showRowDisplay]="false"
              >
              </app-table-pagination-client>
            </div>
          </div>

          <!-- Edit Selected Step -->
          <div *ngIf="selectedStep" class="steps-form__section steps-form__edit" [@fade]>
            <h6 class="steps-form__heading">Edit Step</h6>
            <div class="steps-form__edit-grid">
              <div class="detail-form__group">
                <label class="detail-form__label">Step</label>
                <input
                  class="detail-form__input"
                  #order_step
                  type="text"
                  [disabled]="!selectedStep"
                  [value]="selectedStep?.step"
                />
              </div>
              <div class="detail-form__group">
                <label class="detail-form__label">Status</label>
                <select
                  class="detail-form__input"
                  [disabled]="!selectedStep"
                  (change)="changeOrderStepStatus($event)"
                  *ngIf="orderStatusAll"
                >
                  <option
                    *ngFor="let step of orderStatusAll"
                    [value]="step | json"
                    [selected]="selectedOrderStep?.id === step.id"
                  >
                    {{ step.description }}
                  </option>
                </select>
              </div>
            </div>
            <div class="steps-form__edit-actions">
              <button
                *ngIf="selectedStep?.step === 'Authorization' && (selectedOrderStep?.id === 2 || selectedOrderStep?.id === 3)"
                class="btn btn-primary style-btn btn-sm"
                (click)="createForm()"
              >
                Create Form
                <i class="fa fa-floppy-o ml-1" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="selectedStep"
                class="btn btn-primary style-btn btn-sm"
                (click)="updateOrderStep(order_step)"
              >
                Update
                <i class="fa fa-floppy-o ml-1" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <!-- Step Comments -->
          <div *ngIf="selectedStep" class="steps-form__section">
            <h6 class="steps-form__heading">Step Comments</h6>
            <app-table-pagination-client
              [headers]="orderStepCommentsTableHeaders"
              [data]="selectedOrderStepsCommentsTableData"
              [hasActions]="false"
              [addContent]="addStepComment"
              [pageSize]="2"
              [currentPage]="1"
            >
            </app-table-pagination-client>
          </div>
        </div>
        </div>
        </div>
        </div>

        <!-- Section 1: Tables Grid (BOTTOM) -->
        <div *ngIf="selectedOrderDetails" class="tables-grid-section">
          <div class="tables-grid">
            <!-- Row 1: Comments | Insurance Forms -->
            <div class="grid-table-cell">
              <div class="grid-table-cell__header">
                <h6 style="margin: 0">Comments</h6>
              </div>
              <div class="grid-table-cell__body">
                <div class="table-data__wrapper table-responsive calendar-data--table border-bottom">
                  <app-table-pagination-client
                    [headers]="orderCommentsTableHeaders"
                    [data]="selectedOrderCommentsTableData"
                    [hasActions]="false"
                    [addContent]="addComment"
                    [pageSize]="2"
                    [currentPage]="1"
                  >
                  </app-table-pagination-client>
                </div>
              </div>
            </div>
            <div class="grid-table-cell">
              <div class="grid-table-cell__header">
                <h6 style="margin: 0">Insurance Forms</h6>
              </div>
              <div class="grid-table-cell__body">
                <table class="table table-bordered custom-insurance-forms-table">
                  <thead>
                    <tr>
                      <th>File Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let form of InsuranceFormsData; let i = index">
                      <td>{{ form.file_name }}</td>
                      <td class="small-column">
                        <button
                          class="btn btn-primary name-change-btn action-btn"
                          (click)="previewInsuranceForm(form)"
                          title="Preview Form"
                        >
                          <i style="color: white" class="fa fa-print" aria-hidden="true"></i>
                        </button>
                        <button
                          class="btn btn-danger delete-btn action-btn"
                          (click)="deleteInsuranceForm(form.id,form.order_id)"
                          title="Delete Form"
                        >
                          <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Row 2: Notes | Attachments -->
            <div class="grid-table-cell">
              <div class="grid-table-cell__header">
                <h6 style="margin: 0">Notes</h6>
                <button
                  type="button"
                  ngbTooltip="Download Notes CSV"
                  (click)="downloadNotesCSV()"
                  placement="left"
                  class="btn btn-sm grid-table-cell__action-btn"
                >
                  <i class="fas fa-cloud-download"></i>
                </button>
              </div>
              <div class="grid-table-cell__body">
                <table class="table table-bordered custom-notes-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Contact Time</th>
                      <th>Comments</th>
                      <th>Employee</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let note of OrderStepsNotesData">
                      <td class="small-column">{{ note.note_date }}</td>
                      <td class="small-column">{{ note.note_time }}</td>
                      <td><div [innerHTML]="note.description"></div></td>
                      <td class="small-column">{{ note.created_by }}</td>
                      <td class="small-column">
                        <button
                          class="btn btn-primary name-change-btn action-btn"
                          (click)="editNote(note)"
                          title="Edit Note"
                        >
                          <i class="fa fa-edit" aria-hidden="true"></i>
                        </button>
                        <button
                          class="btn btn-danger delete-btn action-btn"
                          (click)="deleteOrderNote(note.id)"
                          title="Delete Note"
                        >
                          <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="grid-table-cell"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
              [class.drag-over]="isDragOver"
            >
              <div class="grid-table-cell__header">
                <h6 style="margin: 0">Attachments</h6>
                <button
                  type="button"
                  ngbTooltip="Upload Attachment"
                  placement="left"
                  class="btn btn-sm grid-table-cell__action-btn"
                  (click)="uploadAttachment()"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
              <div class="grid-table-cell__body">
                <app-table-pagination-client
                  [headers]="attachementsTableHeader"
                  [data]="selectedAttachmentsTableData"
                  [hasActions]="true"
                  [previewFunction]="previewFunction"
                  [deleteFunction]="deleteOrderAttachment"
                  [pageSize]="5"
                  [paginateId]="4"
                  [currentPage]="1"
                >
                </app-table-pagination-client>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li
      [ngbNavItem]="3"
      *ngIf="
        benefits &&
        this.userRole !== 'location_user' &&
        this.userRole !== 'location_admin'
      "
    >
      <a class="ngbNavLink" ngbNavLink>Benefits</a>
      <ng-template ngbNavContent>
        <!-- Patient Information -->
        <div *ngIf="selectedOrder && selectedOrderDetails" class="d-flex flex-wrap gap-3 mt-3">
          <h6>
            Patient Name:
            <strong
              >{{ selectedOrder.patient.last_name }},
              {{ selectedOrder.patient.first_name }}</strong
            >
          </h6>
          <div
            *ngIf="this.userRole !== 'location_admin' && this.userRole !== 'location_user'"
            class="rename-btn"
          >
            <i
              class="fa fa-pencil-square fa-lg pointer"
              (click)="updatePatient()"
              aria-hidden="true"
            ></i>
          </div>
          <h6 class="ml-5">
            DOB: <strong>{{ selectedOrder.patient.date_of_birth }}</strong>
          </h6>
          <h6 class="ml-5">
            MRN: <strong>{{ selectedOrder.patient.med_rec_nbr }}</strong>
          </h6>
          <h6 class="ml-5">
            <label>
              Enrolled:
              <input
                onclick="this.checked=!this.checked;"
                type="checkbox"
                [checked]="patient_enrolled"
            /></label>
          </h6>
          <h6 class="ml-3">Primary Payer ID: <strong>{{ selectedOrderDetails?.primary_payer_id || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Name: <strong>{{ selectedOrderDetails?.primary_payer_name || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Group: <strong>{{ selectedOrderDetails?.primary_payer_group || 'N/A' }}</strong></h6>
        </div>

        <!-- Order Benefits -->
        <div
          *ngIf="selectedOrderDetails"
          class="right__panel calendar-data__wrapper mb-4"
        >
          <h6 class="mt-3" style="margin-left: 20px">
            Insurance:
            <select
              class="order-inputs"
              (change)="changeOrderBenefitInsurancePayer($event)"
              style="width: 15rem"
              [disabled]="selectedOrderDetails?.client?.payers?.client"
            >
              <option selected value="" disabled hidden>
                Select Insurance
              </option>
              <option
                *ngFor="let payer of selectedOrderDetails.client.payers"
                [value]="payer | json"
              >
                {{ payer.description }}
              </option>
            </select>
          </h6>
          <div
            class="table-data__wrapper table-responsive calendar-data--table border-bottom"
          >
            <h6 style="margin-top: 20px; margin-left: 20px">Procedures</h6>
            <div class="d-flex benefits-detail">
              <div style="position: relative">
                <button
                  *ngIf="benefitProcedureTableData"
                  class="ml-4 btn add-benefit-insurance-btn style-btn"
                  (click)="addOrderBenefitInsurance()"
                >
                  Add <i class="fa fa-plus ml-1" aria-hidden="true"></i>
                </button>
                <app-table-draggable
                  [headers]="orderBenefitProcedureTableHeaders"
                  [dataSource]="benefitProcedureTableData"
                  [payerMPPR]="selectedPayerMPPR"
                  [calculateAllowable]="calculateAllowable"
                  [reorderContent]="reorderOrderBenefitInsurance"
                  [totalAllowable]="totalAllowable"
                  [hasActions]="true"
                  [deleteFunction]="deleteOrderBenefits"
                >
                </app-table-draggable>
              </div>

              <div class="edit-benefits">
                <div *ngIf="selectedOrderDetails">
                  <h6>
                    Allowable: <span>$</span>
                    <input
                      #order_benefit_allowables
                      type="text"
                      (change)="
                        evaluateEstOutOfPocketOnChange(
                          order_benefit_allowables.value,
                          order_benefit_deductable.value,
                          order_benefit_amount_met.value,
                          order_benefit_coinsurance.value,
                          patient_responsibility.value
                        )
                      "
                      [min]="0"
                      [disabled]="!selectedOrderDetails"
                      [value]="
                        selectedOrderDetails?.benefits[0]?.allowable ||
                        totalAllowable
                      "
                      appTwoDigitDecimaNumber
                    />
                  </h6>
                  <h6>
                    Deductable: <span>$</span>
                    <input
                      #order_benefit_deductable
                      type="text"
                      (change)="
                        evaluateEstOutOfPocketOnChange(
                          order_benefit_allowables.value,
                          order_benefit_deductable.value,
                          order_benefit_amount_met.value,
                          order_benefit_coinsurance.value,
                          patient_responsibility.value
                        )
                      "
                      min="0"
                      [disabled]="!selectedOrderDetails"
                      [value]="selectedOrderDetails?.benefits[0]?.deductable"
                      appTwoDigitDecimaNumber
                    />
                  </h6>
                  <h6>
                    Amount Met: <span>$</span>
                    <input
                      #order_benefit_amount_met
                      type="text"
                      (change)="
                        evaluateEstOutOfPocketOnChange(
                          order_benefit_allowables.value,
                          order_benefit_deductable.value,
                          order_benefit_amount_met.value,
                          order_benefit_coinsurance.value,
                          patient_responsibility.value
                        )
                      "
                      min="0"
                      [disabled]="!selectedOrderDetails"
                      [value]="
                        selectedOrderDetails?.benefits[0]?.deductable_met
                      "
                      appTwoDigitDecimaNumber
                    />
                  </h6>
                  <h6>
                    Coinsurance: <span>%</span>
                    <input
                      #order_benefit_coinsurance
                      type="text"
                      (change)="
                        evaluateEstOutOfPocketOnChange(
                          order_benefit_allowables.value,
                          order_benefit_deductable.value,
                          order_benefit_amount_met.value,
                          order_benefit_coinsurance.value,
                          patient_responsibility.value
                        )
                      "
                      min="0"
                      max="100"
                      [disabled]="!selectedOrderDetails"
                      [value]="selectedOrderDetails?.benefits[0]?.coinsurance"
                      appTwoDigitDecimaNumber
                    />
                  </h6>
                  <h6>
                    Patient Responsibility: <span>$</span>
                    <input
                      type="text"
                      #patient_responsibility
                      (change)="
                        evaluateEstOutOfPocketOnChange(
                          order_benefit_allowables.value,
                          order_benefit_deductable.value,
                          order_benefit_amount_met.value,
                          order_benefit_coinsurance.value,
                          patient_responsibility.value
                        )
                      "
                      min="0"
                      [value]="
                        selectedOrderDetails?.benefits[0]
                          ?.patient_responsibility
                      "
                      appTwoDigitDecimaNumber
                    />
                  </h6>
                  <h6>
                    Out Of Pocket: <span>$</span>
                    <input type="text" disabled [value]="estimateOutOfPocket" />
                  </h6>

                  <button
                    class="btn btn-primary style-btn mb-4"
                    [disabled]="!canUpdateBenefit"
                    (click)="
                      updateOrderBenefit(
                        order_benefit_allowables.value,
                        order_benefit_deductable.value,
                        order_benefit_amount_met.value,
                        order_benefit_coinsurance.value,
                        patient_responsibility.value
                      )
                    "
                  >
                    Save <i class="fa fa-floppy-o ml-1" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="4" *ngIf="appointments">
      <a class="ngbNavLink" ngbNavLink>Appointments</a>
      <ng-template ngbNavContent>
        <!-- Patient Information -->
        <div *ngIf="selectedOrder && selectedOrderDetails" class="d-flex flex-wrap gap-3 mt-3">
          <h6>
            Patient Name:
            <strong
              >{{ selectedOrder.patient.last_name }},
              {{ selectedOrder.patient.first_name }}</strong
            >
          </h6>
          <div
            *ngIf="this.userRole !== 'location_admin' && this.userRole !== 'location_user'"
            class="rename-btn"
          >
            <i
              class="fa fa-pencil-square fa-lg pointer"
              (click)="updatePatient()"
              aria-hidden="true"
            ></i>
          </div>
          <h6 class="ml-5">
            DOB: <strong>{{ selectedOrder.patient.date_of_birth }}</strong>
          </h6>
          <h6 class="ml-5">
            MRN: <strong>{{ selectedOrder.patient.med_rec_nbr }}</strong>
          </h6>
          <h6 class="ml-5">
            <label>
              Enrolled:
              <input
                onclick="this.checked=!this.checked;"
                type="checkbox"
                [checked]="patient_enrolled"
            /></label>
          </h6>
          <h6 class="ml-3">Primary Payer ID: <strong>{{ selectedOrderDetails?.primary_payer_id || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Name: <strong>{{ selectedOrderDetails?.primary_payer_name || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Group: <strong>{{ selectedOrderDetails?.primary_payer_group || 'N/A' }}</strong></h6>
        </div>

        <!-- Order Appointments -->
        <div
          *ngIf="selectedOrderDetails"
          class="right__panel calendar-data__wrapper mb-4"
        >
          <div
            class="table-data__wrapper table-responsive calendar-data--table border-bottom"
          >
            <app-table-pagination-client
              [headers]="orderAppointmentsTableHeaders"
              [data]="selectedOrderAppointmentsTableData"
              [hasActions]="true"
              [addContent]="addOrderAppointment"
              [deleteFunction]="deleteOrderAppointment"
              [pageSize]="6"
              [paginateId]="4"
              [currentPage]="1"
            >
            </app-table-pagination-client>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="5" *ngIf="tasks">
      <a class="ngbNavLink" ngbNavLink>Tasks</a>
      <ng-template ngbNavContent>
        <!-- Patient Information -->
        <div *ngIf="selectedOrder && selectedOrderDetails" class="d-flex flex-wrap gap-3 mt-3">
          <h6>
            Patient Name:
            <strong
              >{{ selectedOrder.patient.last_name }},
              {{ selectedOrder.patient.first_name }}</strong
            >
          </h6>
          <div
            *ngIf="this.userRole !== 'location_admin' && this.userRole !== 'location_user'"
            class="rename-btn"
          >
            <i
              class="fa fa-pencil-square fa-lg pointer"
              (click)="updatePatient()"
              aria-hidden="true"
            ></i>
          </div>
          <h6 class="ml-5">
            DOB: <strong>{{ selectedOrder.patient.date_of_birth }}</strong>
          </h6>
          <h6 class="ml-5">
            MRN: <strong>{{ selectedOrder.patient.med_rec_nbr }}</strong>
          </h6>
          <h6 class="ml-5">
            <label>
              Enrolled:
              <input
                onclick="this.checked=!this.checked;"
                type="checkbox"
                [checked]="patient_enrolled"
            /></label>
          </h6>
          <h6 class="ml-3">Primary Payer ID: <strong>{{ selectedOrderDetails?.primary_payer_id || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Name: <strong>{{ selectedOrderDetails?.primary_payer_name || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Group: <strong>{{ selectedOrderDetails?.primary_payer_group || 'N/A' }}</strong></h6>
        </div>

        <!-- Order Tasks -->
        <div
          *ngIf="selectedOrderDetails"
          class="order-details col-md-12 text-left pl-0 mb-4"
        >
          <div class="row pb-1">
            <div class="col-md-2 text-right order-div-col">&nbsp;</div>
            <div class="col-md-3 pl-0 text-left">
              <h6>Assign a New Task</h6>
            </div>
          </div>
          <div class="row pb-1">
            <div class="col-md-2 text-right order-div-col mt-1">Form:</div>
            <div class="col-md-4 pl-0">
              <select
                class="order-inputs"
                (change)="onOrderTaskSelectChange($event)"
                style="width: 18rem"
                [disabled]="!selectedOrderDetails?.client?.client_forms"
              >
                <option selected value="" disabled hidden>Select a form</option>
                <option
                  *ngFor="let form of selectedOrderDetails.client.client_forms"
                  [value]="form | json"
                >
                  {{ form.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="row pb-1">
            <div class="col-md-2 text-right order-div-col mt-1">
              Task Description:
            </div>
            <div class="col-md-4 pl-0">
              <input class="order-inputs" #task_description type="text" />
            </div>
          </div>

          <div class="row pb-1">
            <div class="col-md-2 text-right order-div-col mt-1">Due Date:</div>
            <div class="pl-0">
              <div class="form-group">
                <div class="input-group" style="margin-right: 0px">
                  <input
                    class="form-control"
                    placeholder="yyyy-mm-dd"
                    name="dp"
                    [(ngModel)]="orderTaskDueDatePickerModel"
                    ngbDatepicker
                    #d="ngbDatepicker"
                  />
                  <div
                    class="input-group-append"
                    style="position: absolute; right: 0; height: 40px"
                  >
                    <button
                      class="btn btn-outline-secondary calendar"
                      (click)="d.toggle()"
                      type="button"
                    >
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row pb-1">
            <div class="col-md-3 text-right order-div-col">&nbsp;</div>
            <div class="col-md-3 pl-0 text-center">
              <button
                class="btn btn-primary style-btn"
                (click)="assignFormToOrder(task_description.value)"
              >
                Assign <i class="fa fa-check ml-1" aria-hidden="true"></i>
              </button>
            </div>
          </div>

          <div
            class="table-data__wrapper table-responsive calendar-data--table border-bottom"
          >
            <app-table-pagination-client
              [headers]="orderFormsTableHeaders"
              [data]="selectedOrderTasksTableData"
              [hasActions]="false"
              [pageSize]="6"
              [paginateId]="5"
              [currentPage]="1"
            >
            </app-table-pagination-client>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="6" *ngIf="attachments">
      <a class="ngbNavLink" ngbNavLink>Attachments</a>
      <ng-template ngbNavContent>
        <!-- Patient Information -->
        <div *ngIf="selectedOrder && selectedOrderDetails" class="d-flex flex-wrap gap-3 mt-3">
          <h6 class="mt-2">
            Patient Name:
            <strong
              >{{ selectedOrder.patient.last_name }},
              {{ selectedOrder.patient.first_name }}</strong
            >
          </h6>
         <div
            *ngIf="this.userRole !== 'location_admin' && this.userRole !== 'location_user'"
            class="rename-btn"
            style="margin-top: 5px">
            <i
              class="fa fa-pencil-square fa-lg pointer"
              (click)="updatePatient()"
              aria-hidden="true"
            ></i>
          </div>
          <h6 class="ml-5 mt-2">
            DOB: <strong>{{ selectedOrder.patient.date_of_birth }}</strong>
          </h6>
          <h6 class="ml-5 mt-2">
            MRN: <strong>{{ selectedOrder.patient.med_rec_nbr }}</strong>
          </h6>
          <h6 class="ml-5 mt-2">
            <label>
              Enrolled:
              <input
                onclick="this.checked=!this.checked;"
                type="checkbox"
                [checked]="patient_enrolled"
            /></label>
          </h6>
          <h6 class="ml-3">Primary Payer ID: <strong>{{ selectedOrderDetails?.primary_payer_id || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Name: <strong>{{ selectedOrderDetails?.primary_payer_name || 'N/A' }}</strong></h6>
          <h6 class="ml-3">Primary Payer Group: <strong>{{ selectedOrderDetails?.primary_payer_group || 'N/A' }}</strong></h6>
          <div style="margin-left: auto; margin-right: 20px">
            <button
              type="button"
              ngbTooltip="Upload Attachment"
              placement="left"
              class="btn add-order-btn"
              (click)="uploadAttachment()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div
          (change)="
            (selectedOrderDetails.attachments || selectedAttachmentsTableData)
          "
        >
          <div
            *ngIf="selectedOrderDetails"
            class="right__panel calendar-data__wrapper"
          >
            <!-- Order Attachments -->
            <div
              *ngIf="selectedOrderDetails"
              class="right__panel calendar-data__wrapper mb-4"
            >
              <div
                class="table-data__wrapper table-responsive calendar-data--table border-bottom"
              >
                <app-table-pagination-client
                  [headers]="attachementsTableHeader"
                  [data]="selectedAttachmentsTableData"
                  [hasActions]="true"
                  [previewFunction]="previewFunction"
                  [deleteFunction]="deleteOrderAttachment"
                  [pageSize]="5"
                  [paginateId]="4"
                  [currentPage]="1"
                >
                </app-table-pagination-client>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
